/* eslint-disable no-undef */
<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="400px" persistent>
      <v-card :loading="loading" class="mx-auto">
        <v-card-title>
          <span class="headline">ASIGNAR</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="text--primary px-8">
          <ValidationObserver ref="form">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <ValidationProvider name="Tipo Usuario" rules="required">
                  <v-autocomplete
                    v-model="tipo"
                    :items="tipoUsuario"
                    label="Tipo Usuario"
                    slot-scope="{ errors, valid }"
                    :error-messages="errors"
                    :success="valid"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <ValidationProvider name="Usuario" rules="required">
                  <v-autocomplete
                    v-model="usuario"
                    :items="usuarios"
                    item-text="nombres"
                    item-value="id"
                    :label="
                      esSalesforce
                        ? 'Buscar usuario por nombre o identificación'
                        : 'Usuario Asignar'
                    "
                    :prepend-inner-icon="
                      esSalesforce ? 'mdi-magnify' : undefined
                    "
                    :no-data-text="
                      esSalesforce
                        ? 'Sin resultados — intenta con otro nombre o identificación'
                        : 'No hay datos disponibles'
                    "
                    required
                    clearable
                    slot-scope="{ errors, valid }"
                    :error-messages="errors"
                    :success="valid"
                  >
                    <template v-slot:item="slotProps">
                      <v-icon
                        class="mr-2"
                        :color="
                          (
                            estadoUsuario.find(
                              (el) => el.value === slotProps.item.estado
                            ) || {}
                          ).color || 'grey'
                        "
                        small
                      >
                        mdi-circle
                      </v-icon>
                      {{ slotProps.item.nombres }}
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-card-text>

        <v-card-actions class="pb-8 pl-8">
          <v-btn @click="save" color="primary" dark :loading="loading">
            Guardar
          </v-btn>
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { db } from "../../firebase";
import moment from "moment-timezone";
export default {
  name: "ModAddAsignar",
  data: () => ({
    loading: false,
    dialog: true,
    tipoUsuario: [],
    tipo: "",
    todoUsuarios: [],
    usuario: "",
    campo: "",
    nuevoEstadoUsuario: "",
    registration_ids: [],
    titulo: "",
    msj: "",
    url: "",
    cargos: [],
    token_cliente: "",
    token_contac: "",
    investigadorInfo: {},
    caso: {},
    esSalesforce: false,
  }),
  created() {
    if (this.logueado.cargo === "Administrador")
      this.tipoUsuario = [
        "Abogado",
        "Abogado CAIT",
        "Call Center",
        "Investigador",
        "Perito",
        "Dibujante",
        "Cancelado",
      ];
    if (this.logueado.cargo === "Coordinador Abogado") {
      this.tipoUsuario = ["Abogado"];
    }
    if (this.logueado.cargo === "Coordinador Contact Center") {
      this.tipoUsuario = ["Call Center"];
    }
    if (this.logueado.cargo === "Coordinador Investigador") {
      this.tipoUsuario = ["Investigador", "Dibujante"];
    }
    if (this.logueado.cargo === "Coordinador Perito") {
      this.tipoUsuario = ["Perito"];
    }
    if (this.logueado.cargo === "Coordinador Abogado CAIT")
      this.tipoUsuario = ["Abogado CAIT"];
  },
  props: {
    id: { type: String, default: "" },
    //areaCaso: { type: String, default: "Sin Definir" },
    idCiudad: { type: String, default: "" },
    showModal: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(["logueado", "estadoUsuario"]),
    usuarios() {
      const mapUsuario = (u) => ({
        id: u.id,
        nombres: `${u.nombres} ${u.apellidos} - ${u.identificacion}`,
        estado: u.disponibilidad,
        token: u.tokenPush,
        cargo: u.cargo,
        nombre_completo: `${u.nombres} ${u.apellidos}`,
      });

      // Cargo "Cancelado": mostrar todos los usuarios con ese cargo
      // sin importar disponibilidad, ciudad u origen del caso
      if (this.tipo === "Cancelado") {
        return this.todoUsuarios
          .filter((el) => el.cargo === "Cancelado")
          .map(mapUsuario);
      }

      // Casos Salesforce: todos los usuarios sin filtro de ciudad
      // La búsqueda la gestiona nativamente el v-autocomplete al escribir
      if (this.esSalesforce) {
        return this.todoUsuarios
          .filter(
            (el) =>
              el.cargo == this.tipo &&
              el.disponibilidad &&
              el.disponibilidad != "Fuera de su horario laboral"
          )
          .map(mapUsuario);
      }

      // Casos normales: filtro por ciudad para Investigador y Abogado
      if (this.tipo == "Investigador" || this.tipo == "Abogado") {
        return this.todoUsuarios
          .filter(
            (el) =>
              el.cargo == this.tipo &&
              el.ciudades &&
              el.ciudades.length > 0 &&
              el.ciudades.some((x) => x == `${this.idCiudad}`) &&
              el.disponibilidad &&
              el.disponibilidad != "Fuera de su horario laboral"
          )
          .map(mapUsuario);
      }

      return this.todoUsuarios
        .filter(
          (el) =>
            el.cargo == this.tipo &&
            el.disponibilidad &&
            el.disponibilidad != "Fuera de su horario laboral"
        )
        .map(mapUsuario);
    },
  },
  async mounted() {
    this.todoUsuarios = await db
      .collection("usuarios")
      .where("cargo", "in", this.tipoUsuario)
      //.where("area", "==", this.areaCaso)
      .get()
      .then((result) => {
        return result.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      });

    // Verificar si el caso es de origen Salesforce
    const docCaso = await db.collection("casos").doc(this.id).get();
    this.esSalesforce =
      docCaso.exists && docCaso.data()?.origen_desde === "Salesforce";
  },
  methods: {
    ...mapActions("notification", ["EnviarNotificaciones"]),
    async save() {
      this.loading = true;
      const validar = await this.$refs.form.validate();
      if (!validar) return false;
      const parametro = {
        modificacion: Date.now(),
        // Fecha y hora en la que se realiza la asignación del caso
        horadeasignacion: new Date(),
      };
      // Guardar siempre quién hizo la asignación del caso
      parametro.uidasignador = this.logueado.id;
      if (this.tipo == "Abogado") {
        this.cargos = [
          "Administrador",
          "Coordinador Contact Center",
          "Coordinador Abogado",
        ];
        this.campo = "uidabogado";
        parametro.uidabogado = this.usuario;
      } else if (this.tipo == "Investigador") {
        this.cargos = ["Administrador", "Coordinador Contact Center"];
        this.campo = "uidinvestigador";
        parametro.uidinvestigador = this.usuario;
      } else if (this.tipo == "Abogado CAIT") {
        this.cargos = ["Administrador"];
        this.campo = "uidabogadocait";
        parametro.uidabogadocait = this.usuario;
      } else if (this.tipo == "Call Center") {
        this.cargos = ["Administrador"];
        this.campo = "uidcontactcenter";
        parametro.uidcontactcenter = this.usuario;
      } else if (this.tipo == "Perito") {
        this.cargos = [
          "Administrador",
          "Coordinador Investigador",
          "Investigador",
        ];
        this.campo = "uidperito";
        parametro.solicitud_perito = true;
        parametro.uidperito = this.usuario;
      } else if (this.tipo == "Dibujante") {
        this.cargos = ["Administrador", "Coordinador Contact Center"];
        this.campo = "uiddibujante";
        parametro.uiddibujante = this.usuario;
      } else if (this.tipo == "Cancelado") {
        this.cargos = ["Administrador"];
        this.campo = "uidcancelado";
        parametro.uidcancelado = this.usuario;
      }
      // se calcula la cantidad de caso para obtener el estado
      try {
        await db.collection("casos").doc(this.id).update(parametro);

        // Consultar el caso para saber si es de Salesforce
        const docCaso = await db.collection("casos").doc(this.id).get();
        const datosCaso = docCaso.exists ? docCaso.data() || {} : {};
        const esSalesforce = datosCaso.origen_desde === "Salesforce";
        if (this.tipo == "Investigador") {
          await this.InvestigadorDet(this.usuario);
          await this.CasoDet();
          await this.notificarSocket("⁠Asignación de caso");

          // Si el caso viene de Salesforce, notificar la asignación del investigador
          if (esSalesforce) {
            await this.notificarAsignacionSalesforce(
              datosCaso.caso,
              this.usuario,
              this.logueado.id
            );
          }
        }
        // Los usuarios con cargo "Cancelado" no cambian su disponibilidad
        // (no se recalcula "Activo ocupado/multiple" para un usuario cancelado)
        if (this.tipo != "Cancelado") {
          const result = await db
            .collection("casos")
            .where(this.campo, "==", this.usuario)
            .where("archivado", "==", false)
            .where("estado", "not-in", [
              "Cancelado",
              "Conciliado",
              "No conciliado",
              "CERRADO",
            ])
            .get();
          this.nuevoEstadoUsuario =
            result.size > 1 ? "Activo multiple" : "Activo ocupado";
          await db
            .collection("usuarios")
            .doc(this.usuario)
            .update({ disponibilidad: this.nuevoEstadoUsuario });
        }
        // se guarda la trazabilidad del caso
        this.$store.dispatch("trazabilidadCaso", {
          descripcion: `El ${this.logueado.cargo} ha asignado un ${this.tipo} al caso`,
          uidcaso: this.id,
          uidcreador: this.logueado.id,
        });
        const name = this.usuarios.find(
          (el) => el.id == this.usuario
        ).nombre_completo;
        const cargo = this.usuarios.find((el) => el.id == this.usuario).cargo;
        const token = this.usuarios.find((el) => el.id == this.usuario).token;
        // se guarda la trazabilidad del estado del usuario
        // (no aplica para "Cancelado": no se modificó su disponibilidad)
        if (this.tipo != "Cancelado") {
          this.$store.dispatch("trazabilidadEstadoUsuarios", {
            descripcion: `Estado actualizado por el ${this.logueado.cargo}`,
            estado: this.nuevoEstadoUsuario,
            uidcaso: this.id,
            cargo: cargo,
            uidcreador: this.logueado.id,
            uidusuario: this.usuario,
          });
        }
        // TODO: REVISAR ENVIO DE NOTIFICACIONES
        this.url = `https://digipats.com.co/gestionar-caso/${this.id}`;
        await this.tokenClienteContact();
        await this.consultarTokens();
        if (token) {
          this.registration_ids = [...this.registration_ids, token];
        }
        this.title = "CASO ASIGNADO";
        this.msj = `EL ${cargo ? cargo.toUpperCase() : cargo} ${
          name ? name.toUpperCase() : name
        } HA SIDO ASIGNADO.`;
        await this.EnviarNotificaciones({
          registration_ids: this.registration_ids,
          title: this.title,
          message: this.msj,
          url: this.url,
        });
        const tituloSwal = esSalesforce
          ? "Operación exitosa y notificada a Salesforce"
          : "Operación Exitosa";
        this.$swal({ icon: "success", title: tituloSwal, text: "" });
        this.loading = false;
        this.cerrarModal();
        this.$emit("actualizar");
      } catch (error) {
        console.log(error);
        this.handleError(error);
      }
    },
    async notificarSocket(momento) {
      moment.tz.setDefault("America/Bogota");
      const identification = this.investigadorInfo.identificacion;
      const caso = this.caso.caso;
      const fechaActual = moment().format("YYYY-MM-DD HH:mm:ss");
      await db.collection("notificaciones").add({
        cedula: identification,
        caso,
        momento,
        fechahora: fechaActual,
      });
    },
    async CasoDet() {
      const infoCaso = await db.collection("casos").doc(this.id).get();
      this.caso = infoCaso.data();
    },
    async InvestigadorDet(investigadorId) {
      console.log("Buscar id", investigadorId);
      const registro = await db
        .collection("usuarios")
        .doc(investigadorId)
        .get();
      if (registro.empty) {
        this.investigadorInfo = {};
      }
      this.investigadorInfo = registro.data();
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
    async notificacionPush(tipo, persona, to) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      if (!to) {
        return;
      }

      const dominio =
        process.env.VUE_APP_AMBIENTE === "sandbox"
          ? "https://sandbox.digipats.com.co"
          : "https://digipats.com.co";
      const ambiente =
        process.env.VUE_APP_AMBIENTE === "sandbox"
          ? process.env.VUE_APP_CLOUDFUNCTIONURL_SANDBOX
          : process.env.VUE_APP_CLOUDFUNCTIONURL;
      const url = `${ambiente}/enviarNotificacionFcm`;

      const raw = JSON.stringify({
        tokens: [to],
        message: {
          notification: {
            title: "CASO ASIGNADO",
            body: `EL ${tipo} ${persona} HA SIDO ASIGNADO.`,
          },
          data: {
            url: dominio,
          },
        },
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(url, requestOptions)
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.log("error", error));
    },
    async tokenClienteContact() {
      try {
        const objCaso = await db.collection("casos").doc(this.id).get();
        const { uidconductor, uidcontactcenter } = objCaso.data();
        if (uidconductor) {
          const objCliente = await db
            .collection("clientes")
            .doc(uidconductor)
            .get();
          const { tokenPush } = objCliente.data();
          if (tokenPush) {
            this.token_cliente = tokenPush;
          }
        }

        if (uidcontactcenter) {
          const objContact = await db
            .collection("usuarios")
            .doc(uidcontactcenter)
            .get();
          const { tokenPush } = objContact.data();
          if (tokenPush) {
            this.token_contac = tokenPush;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * Notifica al backend de VML la asignación de un investigador en un caso de Salesforce.
     * El backend obtiene el access_token de Salesforce y reenvía la información.
     */
    async notificarAsignacionSalesforce(
      numeroCaso,
      idInvestigador,
      idAgenteVML
    ) {
      try {
        const BACKEND_URL =
          //dev
          //"http://127.0.0.1:8000/api/salesforce/notificar-asignacion";
          //prod
          "https://vmltechnologies.com/VML.FleetManager.Backend/public/api/salesforce/notificar-asignacion";

        // Fecha de asignación en ISO 8601 con zona horaria de Colombia (-05:00)
        const fechaAsignacion = moment
          .tz(new Date(), "America/Bogota")
          .format("YYYY-MM-DDTHH:mm:ssZ");

        const payload = {
          vmlNumeroCaso: String(numeroCaso),
          idInvestigador: idInvestigador,
          fechaAsignacion: fechaAsignacion,
          idAgenteVML: idAgenteVML,
        };

        const response = await fetch(BACKEND_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (!response.ok) {
          console.error("[Salesforce] Error al notificar asignación:", data);
        } else {
          console.log(
            "[Salesforce] Asignación notificada correctamente:",
            data
          );
        }
      } catch (error) {
        // No bloquear el flujo si Salesforce falla — solo loguear el error
        console.error("[Salesforce] Excepción al notificar asignación:", error);
      }
    },
    async consultarTokens() {
      try {
        const usuarios = await db
          .collection("usuarios")
          .where("cargo", "in", this.cargos)
          .get();

        const objUsuNotificar = usuarios.docs.map((e) => ({
          ...e.data(),
        }));

        const usu = objUsuNotificar
          .filter((e) => {
            return e.tokenPush;
          })
          .map((u) => {
            return u.tokenPush;
          });
        if (usu.length > 0) {
          this.registration_ids = [
            ...usu,
            this.token_cliente,
            this.token_contac,
          ];
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.div-opciones
    overflow: auto
    height: 240px
</style>
